import React from "react";
import Link from "next/link";
import { SVGLogo } from "@/lib/svg";
import { Anchor } from "./styles";

const Logo: React.FC = () => {
  const LinkComponent = Link as any;
  const SVGLogoComponent = SVGLogo as any;
  return (
    <LinkComponent href="/" passHref>
      <Anchor>
        <SVGLogoComponent />
      </Anchor>
    </LinkComponent>
  );
};

export default Logo;
